module.exports = __webpack_public_path__ + "static/media/nav-icon-1-on-1-invactive.97f642d8.svg";